import React, { useState, useEffect } from 'react'

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { AiOutlinePlus } from "react-icons/ai";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// API
import { getCustomerCities, getCustomerCountries, getCustomerStates } from 'utlis/Apis/Customers_API';

// address component
import AddressBox from './AddressBox';

function ShippingAddress(props) {
    // props
    const { userShippingAddress } = props

    // states
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [sectionLoading, setSectionLoading] = useState(false)
    const [editAddressViewVisibility, setEditAddressViewVisibility] = useState(false)

    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    // initial form values
    const initialFormValues = {
        companyName: "",
        country: '',
        state: '',
        city: '',
        zipCode: '',
        firstName: '',
        lastName: '',
        address: '',
        phone: '',
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        companyName: Yup.string(),
        country: Yup.string().required('This field is required'),
        state: Yup.string().required('This field is required'),
        city: Yup.string().required('This field is required'),
        zipCode: Yup.string().required('This field is required'),
        firstName: Yup.string().required('This field is required'),
        lastName: Yup.string().required('This field is required'),
        address: Yup.string().required('This field is required'),
        phone: Yup.number().required('This field is required'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // get countries
    const getCountries = (callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerCountries().then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            // setting formik value
            formik.setFieldValue("state", "choose")

            if (resData.success) {
                setCountries(resData.data)

                // callback
                callBack()
            }
            if (resData.error) {
                console.log('Error occured while loading countries', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCountries api ", err);
        })
    }

    // get states
    const getStates = (countryId, callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerStates(countryId).then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            // setting formik value
            formik.setFieldValue("city", "choose")

            if (resData.success) {
                setStates(resData.data)

                // callback
                callBack()

                if (!resData?.data?.length) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.info("No city found from the selected state", {
                        autoClose: 2500,
                    });
                }

            }
            if (resData.error) {
                console.log('Error occured while loading countries', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCountries api ", err);
        })
    }

    // get states
    const getCities = (regionId, callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerCities(regionId).then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            if (resData.success) {
                setCities(resData.data)

                // callback
                callBack()

                if (!resData?.data?.length) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.info("No city found from the selected state", {
                        autoClose: 2500,
                    });
                }
            }
            if (resData.error) {
                console.log('Error occured while loading countries', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCountries api ", err);
        })
    }

    // country change
    const handleCountryChange = (ev) => {
        const inpVal = ev.target.value
        if (inpVal) {
            getStates(inpVal)
        }
    }

    // state change
    const handleStateChange = (ev) => {
        const inpVal = ev.target.value
        if (inpVal) {
            getCities(inpVal)
        }
    }


    return (
        <React.Fragment>
            <div className="header-sec">
                <p className="head text-capitalize st-fw-800 mb-2">Shipping Address</p>
                <p className="desc">
                    List of all your shipping addresses
                </p>
            </div>

            <div className="address-lists">
                <div className="inner d-flex flex-wrap">
                    {
                        userShippingAddress?.length && userShippingAddress?.map(item => {
                            return (
                                <AddressBox
                                    key={item.addressId}
                                    dataItem={item}
                                />
                            )
                        })
                    }
                    <div className="frac add-address">
                        <div className="frac-inner h-100 d-flex align-items-center justify-content-center cursor-pointer">
                            <div className="inner text-center st-fw-600 text-capitalize">
                                <AiOutlinePlus fontSize={20} />
                                <span className="d-block st-fs-15 mt-2">add new address</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                // edit shipping address form
                editAddressViewVisibility ? (
                    <div className="form-content position-relative form-item">
                        <div className="header-sec">
                            <p className="head text-capitalize st-fw-800 mb-2">Update Shipping Address</p>
                            <p className="desc">
                                Update your shipping address details.
                            </p>
                        </div>

                        <form
                            onSubmit={formik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            <div className="d-flex flex-wrap">
                                <div className={`form-lt form-item ${(formik.touched.firstName && formik.errors.firstName) ? "has-error" : ""}`}>
                                    <label className="mb-1">First Name <span className="st-fs-12">(required)</span></label>
                                    <input
                                        type="text"
                                        className="form-control default-form-input rounded-0"
                                        {...formik.getFieldProps('firstName')}
                                    />
                                    {
                                        (formik.touched.firstName && formik.errors.firstName) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.firstName}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-rt form-item ${(formik.touched.lastName && formik.errors.lastName) ? "has-error" : ""}`}>
                                    <label className="mb-1">Last Name <span className="st-fs-12">(required)</span></label>
                                    <input
                                        type="text"
                                        className="form-control default-form-input rounded-0"
                                        {...formik.getFieldProps('lastName')}
                                    />
                                    {
                                        (formik.touched.lastName && formik.errors.lastName) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.lastName}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-ct form-item ${(formik.touched.companyName && formik.errors.companyName) ? "has-error" : ""}`}>
                                    <label className="mb-1">Company Name</label>
                                    <input
                                        type="text"
                                        className="form-control default-form-input rounded-0"
                                        {...formik.getFieldProps('companyName')}
                                    />
                                    {
                                        (formik.touched.companyName && formik.errors.companyName) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.companyName}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-ct form-item ${(formik.touched.country && formik.errors.country) ? "has-error" : ""}`}>
                                    <label className="mb-1">Country <span className="st-fs-12">(required)</span></label>
                                    <select
                                        className="form-control default-form-input rounded-0"
                                        {...formik.getFieldProps('country')}
                                        onChange={ev => {
                                            formik.handleChange(ev)
                                            handleCountryChange(ev)
                                        }}
                                    >
                                        <option disabled value="choose">Please choose</option>
                                        {
                                            countries?.length ? countries.map(item => (
                                                <React.Fragment key={item.country_id}>
                                                    <option value={item.country_id}>{item.country}</option>
                                                </React.Fragment>
                                            )) : null
                                        }
                                    </select>
                                    {
                                        (formik.touched.country && formik.errors.country) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.country}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-lt form-item ${(formik.touched.state && formik.errors.state) ? "has-error" : ""}`}>
                                    <label className="mb-1">State <span className="st-fs-12">(required)</span></label>
                                    <select
                                        className={`form-control default-form-input rounded-0 ${(formik?.values?.country?.length === 0) ? "disabled" : ""}`}
                                        disabled={(formik?.values?.country?.length === 0)}
                                        {...formik.getFieldProps('state')}
                                        onChange={ev => {
                                            formik.handleChange(ev)
                                            handleStateChange(ev)
                                        }}
                                    >
                                        <option disabled value="choose">Please choose</option>
                                        {
                                            states?.length ? states.map(item => (
                                                <React.Fragment key={item.region_id}>
                                                    <option value={item.region_id}>{item.region}</option>
                                                </React.Fragment>
                                            )) : null
                                        }
                                    </select>
                                    {
                                        (formik.touched.state && formik.errors.state) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.state}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-rt form-item ${(formik.touched.city && formik.errors.city) ? "has-error" : ""}`}>
                                    <label className="mb-1">City <span className="st-fs-12">(required)</span></label>
                                    <select
                                        className={`form-control default-form-input rounded-0 ${((formik?.values?.country?.length === 0) || (formik?.values?.state?.length === 0)) ? "disabled" : ""}`}
                                        disabled={((formik?.values?.country?.length === 0) || (formik?.values?.state?.length === 0))}
                                        {...formik.getFieldProps('city')}
                                    >
                                        <option disabled value="choose">Please choose</option>
                                        {
                                            cities?.length ? cities.map(item => (
                                                <React.Fragment key={item.city_id}>
                                                    <option value={item.city_id}>{item.city}</option>
                                                </React.Fragment>
                                            )) : null
                                        }
                                    </select>
                                    {
                                        (formik.touched.city && formik.errors.city) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.city}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-ct form-item ${(formik.touched.address && formik.errors.address) ? "has-error" : ""}`}>
                                    <label className="mb-1">Address <span className="st-fs-12">(required)</span></label>
                                    <textarea
                                        className="form-control default-form-input rounded-0"
                                        rows="1"
                                        {...formik.getFieldProps('address')}></textarea>
                                    {
                                        (formik.touched.address && formik.errors.address) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.address}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-lt form-item ${(formik.touched.zipCode && formik.errors.zipCode) ? "has-error" : ""}`}>
                                    <label className="mb-1">Zip Code <span className="st-fs-12">(required)</span></label>
                                    <input
                                        type="text"
                                        className="form-control default-form-input rounded-0"
                                        {...formik.getFieldProps('zipCode')}
                                    />
                                    {
                                        (formik.touched.zipCode && formik.errors.zipCode) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.zipCode}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                <div className={`form-rt form-item ${(formik.touched.phone && formik.errors.phone) ? "has-error" : ""}`}>
                                    <label className="mb-1">Phone <span className="st-fs-12">(required)</span></label>
                                    <input
                                        type="number"
                                        className="form-control default-form-input rounded-0"
                                        {...formik.getFieldProps('phone')}
                                    />
                                    {
                                        (formik.touched.phone && formik.errors.phone) ? (
                                            <div className="error-msg st-fs-12 text-danger position-absolute">
                                                {formik.errors.phone}
                                            </div>
                                        ) : null
                                    }
                                </div>

                                {/* btns */}
                                <div className="btns w-100 pt-2">
                                    <button type="submit" className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn" disabled={btnDisabled}>
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                ) : null
            }

            {
                /* LOADING */
                sectionLoading ? (
                    <div className="section-loading position-absolute align-items-center d-flex h-100 justify-content-center section-loading w-100" style={{ top: 0, left: 0, background: "rgba(255,255,255,0.5)" }}>
                        <Spinner animation="border" />
                    </div>
                ) : null
            }
        </React.Fragment>
    )
}



const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
        currentUser: state.auth.currentUser,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     };
// };

export default connect(getDataFromStore, null)(ShippingAddress);